export default __webpack_public_path__ + "static/media/Group621.c2117ca1.png";